export class CurrentQuery {
  value: string;
  valueWithTag: string;
}
